"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var querystring_builder_1 = require("@aws-sdk/querystring-builder");

function formatUrl(request) {
  var protocol = request.protocol,
      path = request.path,
      hostname = request.hostname,
      port = request.port,
      query = request.query;

  if (protocol && protocol.substr(-1) !== ":") {
    protocol += ":";
  }

  if (port) {
    hostname += ":" + port;
  }

  if (path && path.charAt(0) !== "/") {
    path = "/" + path;
  }

  var queryString = query ? querystring_builder_1.buildQueryString(query) : "";

  if (queryString && queryString[0] !== "?") {
    queryString = "?" + queryString;
  }

  return protocol + "//" + hostname + path + queryString;
}

exports.formatUrl = formatUrl;